import { render, staticRenderFns } from "./formOptions.vue?vue&type=template&id=a20ef1a0&scoped=true&"
import script from "./formOptions.vue?vue&type=script&lang=js&"
export * from "./formOptions.vue?vue&type=script&lang=js&"
import style0 from "./formOptions.vue?vue&type=style&index=0&id=a20ef1a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a20ef1a0",
  null
  
)

export default component.exports